import React from "reactn";
import { MemberShip1, MemberShip2 } from "../../assets";
import axios from "axios";
import "../../assets/css/componentSpecificCss/membershipManage.css";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import { InviteOverview } from "../../components/partner/InviteOverview";

class ManageMemberships extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      filter: "",
      detailsModalShown: false,
      modalData: [],
      original: {},
      totalInvites: 0,
      invitesAccepted: 0
    };
    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Manage Memberships", to: "/memberships/manage" }
      ]
    });
  }

  viewDetail = async row => {
    this.setState({ detailsModalShown: true, modalData: row });
  };
  viewComments = async row => {
    this.setState({ commentsModalShown: true, modalData: row });
  };
  daysInSystem = (r, i) => {
    return (
      <td key={i}>
        {parseInt((Date.now() - new Date(r.insys).getTime()) / (3600000 * 24))}
      </td>
    );
  };
  async componentDidMount() {
    const startTime = new Date().getTime();
    this.setGlobal({ loading: true });
    const ep = `${process.env.REACT_APP_API}/partners/memberships/list_manage`;
    const results = await axios.get(ep);

    let data = results.data.data;

    if (results.data.success) {
      const published = data
        .filter(item => item.published)
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        .sort((a, b) => a.display_order - b.display_order);
      const unpublished = data
        .filter(item => !item.published)
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

      const allMembership = published.concat(unpublished);

      this.setState({
        data: allMembership.filter(r => r.prices.length)
      });
    }

    const ep2 = `${process.env.REACT_APP_API}/partners/invitations/overview/memberships`;
    const results2 = await axios.get(ep2);
    if (results2.data.success) {
      this.setState({
        totalInvites: results2.data.data.totalInvites,
        invitesAccepted: results2.data.data.invitesAccepted
      });
    }
    this.setGlobal({ loading: false });
    console.log("Time Taken", new Date().getTime() - startTime);
  }

  lowestPrice(arr) {
    return arr.reduce(
      (p, c) =>
        p.price_per_term < JSON.parse(c).price_per_term ? p : JSON.parse(c),
      JSON.parse(arr[0])
    );
  }
  render() {
    return (
      <div className="admin">
        <div className="container-fluid adminprofiles">
          <div className="cont invites-title-wrapper">
            <h1>Memberships</h1>
            <InviteOverview
              totalInvites={this.state.totalInvites}
              invitesAccepted={this.state.invitesAccepted}
              listingType="Membership"
            />
          </div>
          <div className="cont">
            {this.state.data.length > 0 ? (
              <div className="tablecont">
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {this.state.data.map((e, key) => (
                    <div
                      className="membership-cards"
                      style={{
                        backgroundColor: "white",
                        width: "300px",
                        borderRadius: "10px",
                        marginRight: "10px",
                        cursor: "pointer"
                      }}
                      onClick={_ =>
                        this.props.history.push(
                          `/partners/memberships/manage/single/${e.id}`
                        )
                      }
                      key={key}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "180px",
                          position: "relative"
                        }}
                      >
                        <LazyLoadImage
                          src={
                            e.membership_image === 2
                              ? `${process.env.REACT_APP_DS_FILES_S3}/${e.membership_image_url}`
                              : e.membership_image === 0
                              ? MemberShip1
                              : MemberShip2
                          }
                          alt="Membership"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover"
                          }}
                          wrapperProps={{
                            style: {
                              width: "100%",
                              height: "100%",
                              objectFit: "cover"
                            }
                          }}
                          effect="opacity"
                        />
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "12px",
                          marginTop: "5px",
                          marginBottom: "5px"
                        }}
                      >
                        {e.membership_name}
                      </p>
                      <p
                        style={{
                          textAlign: "center",
                          color: "grey",
                          fontSize: "10px",
                          marginTop: "5px",
                          marginBottom: "5px"
                        }}
                      >
                        Starting at ${this.lowestPrice(e.prices).price_per_term}{" "}
                        / {this.lowestPrice(e.prices).membership_term} Month(s)
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "5px"
                        }}
                      >
                        <span
                          style={{
                            flexGrow: 1,
                            color: "lightgrey",
                            fontSize: "12px",
                            marginLeft: "5px"
                          }}
                        >
                          {/* {key + 1} / {this.state.data.length} */}
                          {e.max_amount && e.enrolledNum / e.max_amount >= 1 ? (
                            <strong
                              style={{
                                flexGrow: 1,
                                color: "#1BC889",
                                fontSize: "12px",
                                marginLeft: "0px"
                              }}
                            >
                              Full
                            </strong>
                          ) : (
                            `${e.enrolledNum} enrolled / ${
                              e.max_amount ? e.max_amount : "unlimited"
                            } spots`
                          )}
                        </span>
                        <img
                          src="/static/media/monthlysurvey.122ae06e.svg"
                          alt=""
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  height: "60vh",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <p
                  style={{
                    fontStyle: "italic",
                    textAlign: "center",
                    fontSize: "18px"
                  }}
                >
                  Click{" "}
                  <b>
                    <Link to="/partners/memberships/list">here</Link>
                  </b>{" "}
                  to start creating your own memberships!
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ManageMemberships;
